@if (_active) {
  <kendo-window
    title="Edit Record"
    (close)="_closeForm()"
    (stateChange)="_onStateChanges($event)"
    class="barcodeWindow">
    <form novalidate
      [formGroup]="_form"
      class="form_style">
      <div class="row enterpsriseRowStyle">
        <div class="col-12">
          <div class="mainBarcodeContainer">
            <div class="row">
              <div class="col-12">
                <div class="hederBarcodeTitle">Barcode</div>
                <div class="buttonssection">
                  <ul class="buttonssectionList">
                    <li (click)="_onSave($event)"><span><img class="SaveIcone"
                    [src]="'/assets/menu/'+ _theme +'/save-icon.svg'" /></span>Save
                  </li>
                  <li (click)="_onCancel()"><span><img class="closeIcon"
                  [src]="'/assets/menu/'+ _theme +'/close-icon.svg'" /></span>Close
                </li>
              </ul>
            </div>
          </div>
          <div class="col-12">
            <div class="borderSeperator"> </div>
          </div>
          <div class="col-12">
            <div class="row">
              <div class="col-12">
                <div class="form-group special_style_formgroup field-style">
                  <label for="barcodefield"
                  class="control-label">Barcode Field</label>
                  <input type="text" [readonly]="true"
                    class="k-textbox writebox mr-3"
                    placeholder=""
                    formControlName="barcodefield" />
                    <label class="enable-combobox" for="isenabled"
                      >&nbsp;Enabled&nbsp;<input type="checkbox"
                      formControlName="isenabled"
                      class="k-checkbox"
                    kendoCheckBox /></label>
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group special_style_formgroup">
                    <label for="prefix"
                    class="control-label">Prefix</label>
                    <input type="text"
                      class="k-textbox writebox"
                      placeholder=""
                      formControlName="prefix" />
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="form-group special_style_formgroup">
                      <label for="length"
                      class="control-label">Length</label>
                      <input type="text"
                        class="k-textbox writebox"
                        placeholder="Length"
                        formControlName="length"
                        required />
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="form-group special_style_formgroup">
                        <label for="incNumber"
                        class="control-label">Incrementing Number</label>
                        <input type="text"
                          class="k-textbox writebox"
                          placeholder=""
                          formControlName="incrementingnumber"
                          readonly />
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group special_style_formgroup">
                          <label for="setPoint"
                          class="control-label">Counter Setpoint</label>
                          <input type="text"
                            class="k-textbox writebox"
                            placeholder=""
                            formControlName="countersetpoint" />
                          </div>
                        </div>
                        <div class="col-12">
                          <div class="form-group special_style_formgroup">
                            <label for="suffix"
                            class="control-label">Suffix</label>
                            <input type="text"
                              class="k-textbox writebox"
                              placeholder=""
                              formControlName="suffix" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  @if (_invalidForm) {
                    <asap-forms-validation-summary
                      [form]="_form"
                      [page]="'barcodeGenerators'">
                    </asap-forms-validation-summary>
                  }
                </div>
              </div>
            </form>
          </kendo-window>
        }
